import { useState } from "react";

export default function NewsletterSignup({ onClose }) {
  const [formData, setFormData] = useState({
    firstName: "",
    email: "",
    consent: false,
  });
  const [status, setStatus] = useState("");
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.firstName.trim())
      newErrors.firstName = "First Name is required.";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
    }
    if (!formData.consent) {
      newErrors.consent = "You must agree to receive the newsletter.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");
    if (!validate()) return;

    try {
      // Check if we're in development mode
      const isDev = process.env.NODE_ENV === "development";

      if (isDev) {
        // In development, just show success after a short delay
        setTimeout(() => {
          setStatus("success");
          setFormData({
            firstName: "",
            email: "",
            consent: false,
          });
        }, 500);
        return;
      }

      // Production: Submit to Netlify
      const submitData = new URLSearchParams();
      submitData.append("form-name", "newsletter-signup");
      submitData.append("firstName", formData.firstName);
      submitData.append("email", formData.email);
      submitData.append("consent", formData.consent ? "yes" : "no");

      const response = await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: submitData.toString(),
      });

      if (response.ok) {
        setStatus("success");
        setFormData({
          firstName: "",
          email: "",
          consent: false,
        });
      } else {
        setStatus("error");
      }
    } catch (error) {
      setStatus("error");
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="contact-card">
        <button className="modal-close-btn" onClick={onClose}>
          &times;
        </button>

        {status === "success" && (
          <div className="popup-success">
            <h2 style={{ textAlign: "center", marginBottom: "1rem" }}>
              Thank You!
            </h2>
            <p style={{ textAlign: "center", marginBottom: "2rem" }}>
              You've been successfully subscribed to our Quarterly Wealth &
              Wisdom Newsletter for financial tips, tricks and updates!
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <button
                className="primary-btn"
                onClick={onClose}
                style={{ fontSize: "1.2rem", padding: "1rem 2.5rem" }}
              >
                Continue Browsing
              </button>
            </div>
          </div>
        )}
        {status === "error" && (
          <div className="popup-error">
            <p>
              Sorry, there was an error processing your subscription. Please try
              again.
            </p>
            <button className="return-btn" onClick={onClose}>
              Return <span style={{ fontSize: "1.2em" }}>&#8592;</span>
            </button>
          </div>
        )}
        {status === "" && (
          <form
            name="newsletter-signup"
            method="POST"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
            onSubmit={handleSubmit}
          >
            <h2
              style={{
                textAlign: "center",
                marginBottom: "1.5rem",
                color: "#2e3092",
              }}
            >
              Hints and Tips Newsletter Sign-up
            </h2>
            <input type="hidden" name="form-name" value="newsletter-signup" />
            <div style={{ display: "none" }}>
              <label>
                Don't fill this out if you're human: <input name="bot-field" />
              </label>
            </div>
            <div className="form-group">
              <label htmlFor="firstName">First Name: *</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                placeholder="Enter your first name..."
                value={formData.firstName}
                onChange={handleChange}
                required
              />
              {errors.firstName && (
                <span style={{ color: "red" }}>{errors.firstName}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="email">Email: *</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter your email address..."
                value={formData.email}
                onChange={handleChange}
                required
              />
              {errors.email && (
                <span style={{ color: "red" }}>{errors.email}</span>
              )}
            </div>

            <div className="form-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="consent"
                  checked={formData.consent}
                  onChange={handleChange}
                  required
                />
                <span className="checkmark"></span>
                By clicking 'Subscribe,' you acknowledge that you are opting in
                to receive the Quarterly Wealth & Wisdom Newsletter from Own
                Your Money LLC. You'll receive this in your inbox four times a
                year with our best financial tips, tricks, and updates. We value
                your privacy as much as a high-interest savings account—your
                data is safe with us, and you can unsubscribe at any time. *
              </label>
              {errors.consent && (
                <span style={{ color: "red" }}>{errors.consent}</span>
              )}
            </div>

            <button type="submit" className="submit-btn">
              <strong>Subscribe to Newsletter</strong>
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
